import { useFormik } from "formik";
import { DataService } from "../../../services/DataService";
import { createToast } from "../../../utils/toast";
import * as Yup from "yup";
import { Box, Button, TextField } from "@mui/material";
import { useContext } from "react";
import { UserContext } from "../../../contexts/UserContext";
import { _ACTIONS } from "../../../utils/constants";
import { _ROUTES } from "../../../utils/_routes_constants";

export const Comments = ({ params, rowData, onCommentUpdate }) => {
  const dataService = new DataService();
  const { user } = useContext(UserContext);

  const formik = useFormik({
    initialValues: {
      content: rowData?.comments || "",
    },
    validationSchema: Yup.object().shape({
      content: Yup.string().required("Content is required"),
    }),
    onSubmit: (values) => {
      const method = _ACTIONS.POST;
      const url = _ROUTES.ADD_COMMENT;

      dataService.doRequest(
        method,
        url,
        {
          content: values.content,
          site: params.site,
          version: params.version,
          fiscalYear: params.fiscalYear,
          activity: params.activity,
          accountParameter: rowData.account_parameter_id,
          user: user.id,
        },
        {},
        async (data) => {
          if (data.status === 200) {
            createToast("success", "Data saved successfully");
            onCommentUpdate(values.content);
          } else {
            createToast("error", "Data not saved");
          }
        },
      );
    },
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Box>
            <TextField
              id="content"
              name="content"
              label="Your comment..."
              type="textarea"
              multiline
              rows={10}
              value={formik.values.content}
              onChange={formik.handleChange}
              error={formik.touched.content && Boolean(formik.errors.content)}
              helperText={formik.touched.content && formik.errors.content}
              fullWidth
              size="small"
            />
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button type="submit" variant="contained" color="success">
              Save
            </Button>
          </Box>
        </Box>
      </form>
    </>
  );
};
